export enum BlockHrefTypeEnum {

  /**
   * @description
   * link wewnętrzny - do strony systemowej
   */
  INTERNAL_URL_HREF_TYPE = 0,

  /**
   * @description
   * link zewnętrzny - np. www.google.com
   */
  EXTERNAL_URL_HREF_TYPE = 1,

  /**
   * @description
   * link mailto:adres@email.pl
   */
  EMAIL_HREF_TYPE = 2,

  /**
   * @description
   * link do pliku
   */
  FILE_HREF_TYPE = 3,

  /**
   * @description
   * link do obiektu np inwentarza, artysty na podstawie sluga
   */
  OBJECT_HREF_TYPE_SELF = 4,
  /**
   * @description
   * link do zagnieżdżonego obiektu artysty na podstawie sluga
   */
  OBJECT_HREF_TYPE_ARTIST = 5,
  /**
   * @description
   * link do zagnieżdżonego obiektu wystawy na podstawie sluga
   */
  OBJECT_HREF_TYPE_EXHIBITION = 6,
  /**
   * @description
   * link do obiektu nadrzędnego pracy na podstawie sluga
   */
  INTERNAL_URL_HREF_TYPE_PARENT = 7,
}
